import { initializeApp } from "firebase/app";

import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA7pkS-6ctaf4mdCqgte0vHasEv4-IZUfE",
  authDomain: "profilepicturesupload-cdfb0.firebaseapp.com",
  projectId: "profilepicturesupload-cdfb0",
  storageBucket: "profilepicturesupload-cdfb0.appspot.com",
  messagingSenderId: "673858864164",
  appId: "1:673858864164:web:fa309cdad8d757573804b1",
};

const app = initializeApp(firebaseConfig);

export const imageDb = getStorage(app);
